export default __webpack_public_path__ + "static/media/trylleby-property-13.01616da5.jpg";